<template>
  <div>
    <b-tabs pills card vertical>
      <b-tab title="Datos Derivacion" active>
        
          <b-row>
            <b-col>
              <b-card border-variant="light">
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-user"> </i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Identificacion: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      {{ cita.paciente.persona.identificacion }}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-user"> </i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Paciente: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      {{
                        cita.paciente.persona.primerApellido +
                        " " +
                        cita.paciente.persona.primerNombre
                      }}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-stethoscope"> </i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Cuadro Clinico: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      <b-form-textarea v-model="cuadroclinico" disabled>

                      </b-form-textarea>
                      
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-stethoscope"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Doctor: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      {{
                        cita.doctor.idPersona.primerApellido +
                        " " +
                        cita.doctor.idPersona.primerNombre
                      }}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-stethoscope"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Especialidad Interconsulta: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      {{ derivacionespecialidad }}
                    </b-col>
                  </b-row>
                </b-col>

                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-stethoscope"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Hallazgos: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      <b-form-textarea v-model="hallazgos" disabled>

                      </b-form-textarea>
                      
                    </b-col>

                    <b-col v-if="itempro && itempro.length > 0" class="my-1" cols="12">
                      <b-row>
                        <b-col cols="1">
                          <i class="fas fa-stethoscope"></i>
                        </b-col>
                        <b-col cols="3">
                          
                          <label>
                            <b> Procedimiento: </b>
                          </label>
                        </b-col>
                        <b-col cols="8">
                          <b-table
                            :items="itempro"
                            :fields="fieldspro"
                            small
                            responsive
                          >
                            <template #cell(procedimiento)="data">
                              {{ data.item.procedimiento }}
                            </template>
                          </b-table>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col v-if="itemate && itemate.length > 0" class="my-1" cols="12">
                      <b-row>
                        <b-col cols="1">
                          <i class="fas fa-stethoscope"></i>
                        </b-col>
                        <b-col cols="3">
                          <label>
                            <b> Atencion Medica: </b>
                          </label>
                        </b-col>
                        <b-col cols="8">
                          <b-table
                            :items="itemate"
                            :fields="fieldsate"
                            small
                            responsive
                          >
                            <template #cell(atencion)="data">
                              {{ data.item.atencion  }}
                            </template>
                          </b-table>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-card>
            </b-col>
            <b-col>
              <b-card border-variant="light">
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-braille"></i>
                    </b-col>
                    <b-col cols="5">
                      <label>
                        <b> Nivel de derivacion: </b>
                      </label>
                    </b-col>
                    <b-col cols="5">
                      <label>
                        <b>{{ nivelseleccionado }} </b>
                      </label>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-braille"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Motivo de Derivacion: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      {{ motivoderivacion }}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-braille"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Tipo de Derivacion: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      {{ tipoderivacion }}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-calendar"></i>
                    </b-col>
                    <b-col cols="4">
                      <label>
                        <b> Fecha de Derivacion: </b>
                      </label>
                    </b-col>
                    <b-col cols="6">
                      <b-form-datepicker v-model="fechaDerivacion" disabled>
                      </b-form-datepicker>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col v-if="diagnosticos.length > 0" class="my-1" cols="12">
                  <b-row>
                    <b-col cols="1">
                      <i class="fas fa-stethoscope"></i>
                    </b-col>
                    <b-col cols="3">
                      <label>
                        <b> Diagnostico: </b>
                      </label>
                    </b-col>
                    <b-col cols="8">
                      <b-table
                        :items="diagnosticos"
                        :fields="fieldsti"
                        small
                        responsive
                      >
                        <template #cell(tipo)="data">
                          {{ data.item.tipo }}
                        </template>
                        <template #cell(diagnostico)="data">
                          {{ data.item.diagnostico }}
                        </template>
                        <template #cell(principal)="data">
                          {{ data.item.principal ? "Sí" : "No" }}
                        </template>
                       
                      </b-table>
                    </b-col>
                  </b-row>
                </b-col>
              </b-card>
            </b-col>
          </b-row>
          
        
      </b-tab>
      <b-tab title="Documentos Derivacion">
        <b-card>
          <b-row>
            <b-col cols="1">
              <i class="fas fa-file"></i>
            </b-col>
            <b-col cols="1">
              
              <div>
                <h6>Tirilla: </h6>
              </div>
            </b-col>
            <b-col cols="2">
              <label v-if="urlTirillaDerivacion">Disponible</label>
              <label v-else style="color: red;">No Disponible</label>
            </b-col>
            <b-col v-if="urlTirillaDerivacion" cols="1">
              <b-button @click="descargarDocumento(urlTirillaDerivacion)"> <i class="fa-solid fa-magnifying-glass"></i></b-button>
            </b-col>
            <b-col cols="1">
              <i class="fas fa-file"></i>
            </b-col>
            <b-col cols="1">
              <div>
                <h6>Msp: </h6>
              </div>
            </b-col>
            <b-col cols="2">
              <label v-if="ulrMspDerivacion">Disponible</label>
              <label v-else style="color: red;">No Disponible</label>
            </b-col>
            <b-col v-if="ulrMspDerivacion" cols="2">
              <b-button @click="descargarDocumento(ulrMspDerivacion, 'msp')"> <i class="fa-solid fa-magnifying-glass"></i></b-button>
            </b-col>

          </b-row>
         

        </b-card>
      </b-tab>
      <b-tab v-if="contraref && infotecnica" title="Contra Ref/ Inf Tenica"> 
        <b-card>
				<b-row  >
          <b-col v-if = "contraref" cols="12">
            <b-row>
              <b-col cols="12">
						<h5>
							Contra Referencia:
						</h5>
				
					</b-col>
					<b-col cols="6">
						<label>
							Tratamientos Terapeuticos:

						</label>
            {{ contraref ? contraref.tratera ? contraref.tratera : "No disponible": "No disponible" }}
						
					</b-col>
					<b-col cols="6">
						<label>
							Tratamiento Recomendado:

						</label>
            {{ contraref ? contraref.tratereco ? contraref.tratareco : "No disponible": "No disponible" }}

						
					</b-col>
            </b-row>
          </b-col>

					
					<b-col v-if = "infotecnica" class = "mt-2" cols="12">
            <b-row> 
              <b-col > <h5>
							Informacion Tecnica:
						</h5></b-col>
          
					<b-col cols="6">
						<label>
							Fecha informe:

						</label>
						<b-form-datepicker v-model="infotecnica.fechait"
            disabled>

						</b-form-datepicker>
					</b-col>
					<b-col cols="6">
						<label>
							Dirigido a:

						</label>
						<b-form-textarea v-model="infotecnica.dirigidoa"
            disabled>

						</b-form-textarea>
					</b-col>
					<b-col class="mt-1" cols="9">
						<label>
							Observaciones:

						</label>
            {{ infotecnica ? infotecnica.observaciones ? infotecnica.observaciones : "No disponible": "No disponible" }}

						
					</b-col>
            </b-row>
						
				
					</b-col>
					

				</b-row>
      </b-card>
      </b-tab>
      <b-tab v-if ="hispatologia" title="Hispatologia"> 
       <b-card>
        <b-row>
		
      </b-row>
        <b-row  >
					<b-col cols="6">
						<label>
							Tratamiento:

						</label>
            {{ hispatologia.tratamiento ? hispatologia.tratamiento : "No disponible"}}
						
					</b-col>
					<b-col cols="6">
						<label>
							Muestras:

						</label>
            {{ hispatologia.muestras ? hispatologia.muestras : "No disponible" }}
						
					</b-col>
					<b-col cols="12" class="mt-2">
						<label> <b>
							Datos citologia:
						</b>
						</label>
					
					</b-col>
					<b-col cols="6">
						<label>
							Material:

						</label>
						<b-form-checkbox-group
						v-model = "hispatologia.dcitologia.material"
						:options="optionsMaterial"
            disabled>
            
						</b-form-checkbox-group>
            <b-form-input  v-model="hispatologia.dcitologia.materialotro" class="mt-1" v-if="hispatologia.dcitologia.material.includes('Otro')" placeholder="Describa otro..">

</b-form-input>
					</b-col>
					<b-col cols="6">
						<label>
							Anticoncepcion:

						</label>
						<b-form-checkbox-group
						v-model = "hispatologia.dcitologia.antoconcepcion"
						:options="optionsaconcepcion"
            disabled>

						</b-form-checkbox-group>
            <b-form-input class="mt-1" v-model="hispatologia.dcitologia.antoconcepcionotro" v-if="hispatologia.dcitologia.antoconcepcion.includes('Otro')" placeholder="Describa otro..">

            </b-form-input>
					</b-col>
					<b-col class="mt-1" cols="6">
						<label>
							Edades:

						</label>
						<b-row>
							<b-col cols="6">
								<label> Menarquia </label>
								<b-form-area>
                  {{ hispatologia.edad.menarquia || "No disponible" }}
									
								</b-form-area>
							</b-col>
							<b-col cols="6">
								<label> Menopausia </label>
								<b-form-area>
                  {{ hispatologia.edad.menopausia || "No disponible" }}
									
								</b-form-area>
							</b-col>
							<b-col cols="6">
								<label> Inicio Sexual </label>
								<b-form-area>
                  {{ hispatologia.edad.isexual || "No disponible" }}
									
								</b-form-area>
							</b-col>
							</b-row>
					</b-col>
					<b-col class="mt-1" cols="6">
						<label>
							Paridad:

						</label>
						<b-row>
							<b-col cols="6">
								<label> Gestaciones </label>
								<b-form-area>
                  {{ hispatologia.paridad.gestaciones || "No disponible" }}
									
								</b-form-area>
							</b-col>
							<b-col cols="6">
								<label> Partos </label>
								<b-form-area>
                  {{ hispatologia.paridad.partos || "No disponible" }}

									
								</b-form-area>
							</b-col>
							<b-col cols="6">
								<label> Abortos </label>
								<b-form-area>
                  {{ hispatologia.paridad.abortos || "No disponible" }}

									
								</b-form-area>
							</b-col>
							<b-col cols="6">
								<label> Cesareas </label>
								<b-form-area>
                  {{ hispatologia.paridad.cesareas || "No disponible" }}
								
								</b-form-area>
							</b-col>
						</b-row>
						
					</b-col>
					<b-col class="mt-1" cols="6">
						<label>
							Fechas:

						</label>
						<b-row>
							<b-col cols="6">
								<label>Ultima Menstruacion: </label>
								<b-form-datepicker
								v-model="hispatologia.fechas.umens"
                disabled>
                
								</b-form-datepicker>
							</b-col>
							<b-col cols="6">
								<label>Ultimo Parto: </label>
								<b-form-datepicker
								v-model="hispatologia.fechas.uparto"
                disabled>

								</b-form-datepicker>
							</b-col>
							<b-col cols="6">
								<label>Ultima Citologia: </label>
								<b-form-datepicker
								v-model="hispatologia.fechas.ucito"
                disabled>

								</b-form-datepicker>
							</b-col>
						
						</b-row>
						
				
					</b-col>
					<b-col class="mt-1" cols="6">
						<label>
							Terapia hormonal:

						</label>
            {{ hispatologia.terapiahormonal || "No disponible" }}
						
					</b-col>
				</b-row>
      
      
      </b-card>
      </b-tab>
    </b-tabs>
    <b-modal id="modal-document" size="xl">
            <b-card>
            <iframe 
        :src="ruta" 
        width="100%" 
        height="500px"
       
        frameborder="0">>
      </iframe>
    </b-card>
          </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BOverlay,
  BFormGroup,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormDatepicker,
  BTabs,
} from "bootstrap-vue";
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import { comprobarPermisos } from "@/shared/helpers";
import vSelect from "vue-select";

export default {
  components: {
    BCard,
    BFormDatepicker,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BOverlay,
    BLink,
    BBadge,
    BTabs,

    vSelect,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
  },
  props: ["token"],

  data() {
    return {
      ruta: null,
      derivaciones: {},
      ulrMspDerivacion: null,
      urlTirillaDerivacion: null,
      cita: {},
			optionsMaterial: ["Endocervix", "Exocervix", "Pared Vaginal", "Union Escamo Columnar", "Muñon Cervical", "Otro"],
			optionsaconcepcion: ["Oral", "Inyectable", "DIU", "ligadura", "Otro"],
      contraref : null,
      infotecnica : null,
      hispatologia: null,
      motivoderivacion: null,
      opsMotivoDerivaciones: [],
      motivoderivacionotro: null,
      fechaDerivacion: null,
      opsEspecialidad: null,
      tipoderivacion: null,
      opsTipoDerivaciones: [],
      derivacionespecialidad: null,
      tiposervicio: null,
      cuadroclinico: null,
      hallazgos: null,
      procedimiento: null,
      nivelseleccionado: null,
      diagnostico: null,
      atencionmedica: null,
      niveles: ["1", "2", "3"],
      searchAten: "",
      opsAtenciones: [],
      searchProc: "",
      opsProcedimientos: [],
      opsDiagnosticos: [],
      searchQuery: null,
      isLoading: false,
      procedimientotext: null,
      atenciontext: null,
      diagnosticos: [],
      itempro: [],
      itemate: [],
      fieldspro: [
      {
          key: "codigo",
          label: "Codigo",
          thClass: "text-center",
        },
        {
          key: "procedimiento",
          label: "Descripcion",
          thClass: "text-center",
        },
      ],
      fieldsate: [
        {
          key: "codigo",
          label: "Codigo",
          thClass: "text-center",
        },
        {
          key: "atencion",
          label: "Descripcion",
          thClass: "text-center",
        },
      ],
      fieldsti: [
        { key: "tipo", label: "Tipo Diagnostico", thClass: "text-center" },
        {
          key: "diagnostico",
          label: "Descripcion/Codigo",
          thClass: "text-center",
        },
        { key: "principal", label: "Principal", thClass: "text-center" },
      ],
    };
  },
  created() {
    this.fetchProcedimientos();
    comprobarPermisos(this.$route);
    this.fetchAtenciones();
    const tokenDerivacion = this.token;
    console.log("este es el token de derivacion en ver", tokenDerivacion);
    this.fetchDerivaciones(tokenDerivacion);
  },
  methods: {
    async descargarDocumento(url, tipo) {
      let urldownload = ''
      if(tipo === 'msp'){
        urldownload = url[0]
      }else { urldownload = url}
      if (urldownload.startsWith('/')) {
        urldownload = urldownload.substring(1);
        
      }
      if (urldownload) {
        
        const fileName = decodeURIComponent(url);
        const fullDownloadUrl = `${rutas.axios}file/show${fileName}`
        try {
          this.ruta = fullDownloadUrl
          console.log(this.ruta);
          this.$bvModal.show("modal-document");
        } catch (error) {
          this.$swal({
            title: 'Error',
            text: 'Un error ocurrio mientras descarga el archivo',
            icon: 'error',
            confirmButtonText: 'Entendido'
          });
      
      }} else {
        this.$swal({
          title: 'Campos vacíos',
          text: 'El archivo no ha sido subido, por favor actualizar en editar admision',
          icon: 'error',
          confirmButtonText: 'Entendido'
        });
      }
    },
    async fetchProcedimientos() {
      const query = `
        query MyQuery($search: String!) {
          allProcs(search: $search) {
            message
            status
            total
            totalSns
            procedimiento {
              codigo
              descripcion
              precio
              id
              estado
            }
            procedimientosSns {
              id
              codigo
              descripcion
            }
          }
        }
      `;
      const variables = { search: this.searchProc };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });
        const allProcs = response.data.data.allProcs || {};
        const cartera = (allProcs.procedimiento || []).map((item) => ({
          value: item.id,
          text: `${item.descripcion} (${item.codigo})`,
          cod: item.codigo,
          source: "cartera",
        }));
        const sns = (allProcs.procedimientosSns || []).map((item) => ({
          value: `sns-${item.id}`,
          text: `${item.descripcion} (${item.codigo}) [SNS]`,
          cod: item.codigo,
          source: "sns",
        }));
        this.opsProcedimientos = [...cartera, ...sns];
      } catch (error) {
        console.error("Error fetching procedimientos:", error.response.data);
      }
    },
    async fetchAtenciones() {
      const query = `
                   query MyQuery ($search : String!){
  allCarteraAtencion(search: $search) {
    message
    status
    total
    atenciones {
      codTarifa
      descripcion
      id
    }
  }
}
        `;
      const variables = { search: this.searchAten };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });
        this.opsAtenciones =
          response.data.data.allCarteraAtencion.atenciones.map((item) => ({
            value: item.id,
            text: item.descripcion + "( " + item.codTarifa + ")",
          }));
      } catch (error) {
        console.error("Error fetching procedimientos:", error.response.data);
      }
    },

    async fetchDerivaciones(tokenDerivacion, pagina_actual = 1, pageSize) {
      const query = `
              query MyQuery($page:Int , $pageSize: Int, $search: String, $establecimiento: String, $tokenDerivacion: String) { 
                allDerivacionesenviadas(page: $page, pageSize: $pageSize, search: $search, establecimiento: $establecimiento, tokenDerivacion: $tokenDerivacion) {
                    message
                    status
                    total
                    derivaciones {
                    id
                    token
                    atenmedId {
                    cita {
                    paciente {
                        persona {
                        identificacion
                        primerNombre
                        primerApellido
                        }
                    }
                    
                    doctor {
                        idPersona {
                        primerNombre
                        primerApellido
                        }
                        especialidad {
                        descripcion
                        }
                    }
                    establecimiento {
                    Descripcion
                    }
                    }
                    }
                                motivoderivacionId {
                                id
                    descripcion
                  }
                     
                    tipoderivacionId {
                    id
                      descripcion
                    }
                      especialidadInterconsulta {
                        descripcion
                      }
                       fechaDerivacion
                  estadoDerivacion
                  
                  hallazgosDerivacion
                  nivelDerivacion
                  informaciontecnica
                  hispatologia
                  atencionDerivacion
                  contrareferencia
                  diagnosticoDerivacion
                  procedimientoDerivacion
                  cuadroClinico
                  urlTirillaDerivacion
                  urlMsp
                  }
                 
                  

                    }
                }
                                         
           `;

      const variables = {
        tokenDerivacion: tokenDerivacion,
        page: pagina_actual,
        pageSize: pageSize,
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });

        if (response.data.data.allDerivacionesenviadas.status === "Success") {
          if (response.data.data.allDerivacionesenviadas.derivaciones) {
            this.derivaciones =
              response.data.data.allDerivacionesenviadas.derivaciones[0];
            this.cita =
              response.data.data.allDerivacionesenviadas.derivaciones[0].atenmedId.cita;
              this.itempro = this.derivaciones.procedimientoDerivacion ? JSON.parse(this.derivaciones.procedimientoDerivacion) : null;
            
              this.itemate = this.derivaciones.atencionDerivacion ? JSON.parse(this.derivaciones.atencionDerivacion) : null;
            
            this.motivoderivacion = this.derivaciones.motivoderivacionId
              ? this.derivaciones.motivoderivacionId.descripcion
              : null;
            this.tipoderivacion = this.derivaciones.tipoderivacionId
              ? this.derivaciones.tipoderivacionId.descripcion
              : null;
            this.fechaDerivacion = this.derivaciones.fechaDerivacion || null;
            this.cuadroclinico = this.derivaciones.cuadroClinico
            this.hallazgos =
              this.derivaciones.hallazgosDerivacion || "No disponible";
            this.nivelseleccionado = this.derivaciones.nivelDerivacion || null;
            
            this.derivacionespecialidad = this.derivaciones.especialidadInterconsulta
              ? this.derivaciones.especialidadInterconsulta.descripcion
              : "No disponible";
            this.ulrMspDerivacion = JSON.parse(this.derivaciones.urlMsp)
            this.urlTirillaDerivacion = this.derivaciones.urlTirillaDerivacion
            if (this.derivaciones.diagnosticoDerivacion) {
            let diagnosticos = JSON.parse(this.derivaciones.diagnosticoDerivacion)
            this.diagnosticos = diagnosticos
          

            } else {
              this.diagnosticos = []
            }
            
            
            
            if (this.derivaciones.hispatologia){
              let hispatologia = JSON.parse(this.derivaciones.hispatologia)
              this.hispatologia = hispatologia
            } else {
              this.hispatologia = null
            }
            if (this.derivaciones.contrareferencia){
              let contraref = JSON.parse(this.derivaciones.contrareferencia)
              this.contraref = contraref
            } else {
              this.contraref = null
            }
            if (this.derivaciones.informaciontecnica){
              let infotecnica = JSON.parse(this.derivaciones.informaciontecnica)
              this.infotecnica = infotecnica
            } else {
              this.infotecnica = null
            }


            
          }
        } else {
          console.error(
            "Error al obtener la derivacion medica:",
            response.data.message
          );
        }
      } catch (error) {
        console.error("Error al realizar la consulta GraphQL:", error);
      }
    },
  },
};
</script>
